import * as React from 'react';
import axios from 'axios';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { useState } from 'react';
// import * as Modal from 'react-modal';
import { connect } from 'react-redux';
import { AppState } from 'src/redux';
import Modal from 'react-modal';

type FileName = {
  file: {
    attachfilename: string;
    oci_status?: string;
  };
  apiUrl: string;
  sessionId: string;
};

type ModalPopup = {
  image: string;
  modalIsopen: boolean;
  setModalIsopen: Function;
  imageName: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconbutton: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
      justifyContent: 'center',
    },
    iconClose: {
      position: 'absolute',
      right: 0,
    },
    button: {
      margin: theme.spacing(1),
    },
    tooltip: {
      float: 'right',
      marginTop: '-23px',
      marginRight: '-23px',
    },
    image_messagebox: {
      // marginTop: '-65px',
      // marginBottom: '100px',
      // height: '450px',
      // width: '910px',
      height: '90%',
      width: '100%',

    },
  })
);

const ModalPopup = (props: ModalPopup) => {
  const classes = useStyles({});
  Modal.setAppElement('#root');
  return (
    <Modal
      isOpen={props.modalIsopen}
      onRequestClose={() => props.setModalIsopen(false)}
      portalClassName="modal"
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.75)',
        },
        content: {
          top: '26%',
          left: '52.5%',
          right: 'auto',
          bottom: '-1%',
          width: '74%',
          transform: 'translate(-40%, -10%)',
          overflow: 'hidden',
        }
      }}
    >
      <div className={classes.tooltip}>
        <Tooltip title="close" placement="top">
          <IconButton
            aria-label="Cancel"
            onClick={() => props.setModalIsopen(false)}
            className={classes.iconbutton}
          >
            <CancelRoundedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </div>
      <img
        src={props.image}
        alt={props.imageName}
        className={classes.image_messagebox}
        style={{
            width: '95%',
            height: '95%',
            objectFit: 'contain'
          }}
      />
    </Modal>
  );
};

// function PreviewFile(props: FileName) {
//   const { file, apiUrl } = props;
//   const { attachfilename, oci_status } = file;
//   const [modalIsopen, setModalIsopen] = React.useState(false);
//   const [image, setImage] = useState<string>('');
//   const fetchCall = (imageUrl: string) => {
//     const filePath = encodeURIComponent(imageUrl);
    
//     let downloadFrom = 'getDownloadUrl';

//     if (oci_status && oci_status === '1') {
//         downloadFrom = 'getODownloadUrl';
//     }
//     console.log(filePath, 'filePath::::');
//     console.log(downloadFrom, 'downloadFrom::::::');
//     console.log(apiUrl, 'apiUrlapiUrl');
//     console.log(oci_status, 'oci_statusoci_status');
//     axios
//       .get(`${apiUrl}${downloadFrom}?fullPath=${filePath}`)
//       .then((res) => {
//         setImage(res.data.signedUrl);
//         setModalIsopen(true);
//       }).catch((err) => {
//             setImage('/assets/error.jpg');
//             setModalIsopen(true);
//       });
//   };

//   return (
//     <div>
//       <div
//         onClick={() => fetchCall(attachfilename)}
//         style={{ cursor: 'pointer' }}
//       >
//         {attachfilename.split('/').reverse()[0]}
//       </div>
//       <ModalPopup
//         modalIsopen={modalIsopen}
//         setModalIsopen={setModalIsopen}
//         image={image}
//         imageName={attachfilename.split('/').reverse()[0]}
//       />
//     </div>
//   );
// }
function PreviewFile(props: FileName ) {
  const { file, apiUrl, sessionId } = props;
  const { attachfilename, oci_status } = file;
  const [modalIsopen, setModalIsopen] = React.useState(false);
  const [image, setImage] = useState<string>('');
  const fetchCall = (imageUrl: string) => {
    const filePath = encodeURIComponent(imageUrl);
    // const sessionId = props.sessionId || '';
    let downloadFrom = 'getDownloadUrl';

    if (oci_status && oci_status === '1') {
        downloadFrom = 'getODownloadUrl';
    }
    console.log(downloadFrom, 'downloadFrom'); 
    const downloadFromBucket = 'commonBucketFileCheck';

    // axios
    //   .get(`${apiUrl}${downloadFromBucket}?fullPath=${filePath}`)
    //    axios({
    axios({
      url: `${apiUrl}${downloadFromBucket}?fullPath=${filePath}`,
      method: 'GET',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        sessionid: sessionId
      }
    }).then((res) => {
        setImage(res.data.signedUrl);
        setModalIsopen(true);
      }).catch((err) => {
            setImage('/assets/error.jpg');
            setModalIsopen(true);
      });
  };

  return (
    <div>
      <div
        onClick={() => fetchCall(attachfilename)}
        style={{ cursor: 'pointer' }}
      >
        {attachfilename.split('/').reverse()[0]}
      </div>
      <ModalPopup
        modalIsopen={modalIsopen}
        setModalIsopen={setModalIsopen}
        image={image}
        imageName={attachfilename.split('/').reverse()[0]}
      />
    </div>
  );
}

function mapStateToProps(state: AppState) {
    return {
        apiUrl: state.environment.API_URL,
        sessionId: state.user.userDetails.s || '',
    };
}
  
export default connect(mapStateToProps)(PreviewFile);



// WEBPACK FOOTER //
// ./src/components/layouts/PreviewForm.tsx